import * as v5 from "../v5";
import * as v6 from "../v6";

import { createVersionedFunction } from "./versionedFunction";

// ---------------------------------------------------------------------------
// Same-name functions (exist with identical names in v5 and v6)
// ---------------------------------------------------------------------------

export const assignReferrer = createVersionedFunction(v5.assignReferrer, v6.assignReferrer);
export const attachConsumerToInventoryItem = createVersionedFunction(
  v5.attachConsumerToInventoryItem,
  v6.attachConsumerToInventoryItem
);
export const authenticate = createVersionedFunction(v5.authenticate, v6.authenticate);
export const cancelSubscription = createVersionedFunction(v5.cancelSubscription, v6.cancelSubscription);
export const changeConsumerEmail = createVersionedFunction(v5.changeConsumerEmail, v6.changeConsumerEmail);
export const changePassword = createVersionedFunction(v5.changePassword, v6.changePassword);
export const changePhone = createVersionedFunction(v5.changePhone, v6.changePhone);
export const checkIfHasHiddenVerificationController = createVersionedFunction(
  v5.checkIfHasHiddenVerificationController,
  v6.checkIfHasHiddenVerificationController
);
export const consumerSubscribePushNotification = createVersionedFunction(
  v5.consumerSubscribePushNotification,
  v6.consumerSubscribePushNotification
);
export const consumerUnsubscribeAllPushNotifications = createVersionedFunction(
  v5.consumerUnsubscribeAllPushNotifications,
  v6.consumerUnsubscribeAllPushNotifications
);
export const consumerUnsubscribePushNotification = createVersionedFunction(
  v5.consumerUnsubscribePushNotification,
  v6.consumerUnsubscribePushNotification
);
export const createActionVerification = createVersionedFunction(
  v5.createActionVerification,
  v6.createActionVerification
);
export const createFeedbackVote = createVersionedFunction(v5.createFeedbackVote, v6.createFeedbackVote);
/**
 * TODO - createDeliveryEvent is available in v5 only
 * add v6 when available: DESP-148853
 */
export const createDeliveryEvent = v5.createDeliveryEvent;
export const createOrUpdateMarketingCommunication = createVersionedFunction(
  v5.createOrUpdateMarketingCommunication,
  v6.createOrUpdateMarketingCommunication
);
export const createPayment = createVersionedFunction(v5.createPayment, v6.createPayment);
export const paySession = createVersionedFunction(v5.paySession, v6.paySession);
export const createPaymentSession = createVersionedFunction(v5.createPaymentSession, v6.createPaymentSession);
export const dataSubjectAccessRequest = createVersionedFunction(
  v5.dataSubjectAccessRequest,
  v6.dataSubjectAccessRequest
);
export const deactivateConsumer = createVersionedFunction(v5.deactivateConsumer, v6.deactivateConsumer);
export const deleteAddress = createVersionedFunction(v5.deleteAddress, v6.deleteAddress);
export const deleteMarketingCommunication = createVersionedFunction(
  v5.deleteMarketingCommunication,
  v6.deleteMarketingCommunication
);
export const deleteProfile = createVersionedFunction(v5.deleteProfile, v6.deleteProfile);
export const fetchInvoice = createVersionedFunction(v5.getInvoice, v6.getInvoice);
export const findActionVerificationItem = createVersionedFunction(
  v5.findActionVerificationItem,
  v6.findActionVerificationItem
);
export const forgotPassword = createVersionedFunction(v5.forgotPassword, v6.forgotPassword);
export const generateWalletPass = createVersionedFunction(v5.generateWalletPass, v6.generateWalletPass);
export const getAchievements = createVersionedFunction(v5.getAchievements, v6.getAchievements);
export const getAvailableConsents = createVersionedFunction(v5.getAvailableConsents, v6.getAvailableConsents);
export const getAvailableSurveysForConsumer = createVersionedFunction(
  v5.getAvailableSurveysForConsumer,
  v6.getAvailableSurveysForConsumer
);
export const getAvailableVerificationMethodsController = createVersionedFunction(
  v5.getAvailableVerificationMethodsController,
  v6.getAvailableVerificationMethodsController
);
export const getComplaints = createVersionedFunction(v5.getComplaints, v6.getComplaints);
export const getConsumerEligibleRewards = createVersionedFunction(
  v5.getConsumerEligibleRewards,
  v6.getConsumerEligibleRewards
);
export const getConsumerLoyaltyProfile = createVersionedFunction(
  v5.getConsumerLoyaltyProfile,
  v6.getConsumerLoyaltyProfile
);
export const getConsumerOrder = createVersionedFunction(v5.getConsumerOrder, v6.getConsumerOrder);
export const getConsumerPointsHistory = createVersionedFunction(
  v5.getConsumerPointsHistory,
  v6.getConsumerPointsHistory
);
export const getConsumerRewardsCampaignsOrPrizes = createVersionedFunction(
  v5.getConsumerRewardsCampaignsOrPrizes,
  v6.getConsumerRewardsCampaignsOrPrizes
);
export const getConsumerSurveyStatus = createVersionedFunction(v5.getConsumerSurveyStatus, v6.getConsumerSurveyStatus);
export const getConsumerTier = createVersionedFunction(v5.getConsumerTier, v6.getConsumerTier);
export const getContestStatus = createVersionedFunction(v5.getContestStatus, v6.getContestStatus);
export const getCreditCard = createVersionedFunction(v5.getCreditCard, v6.getCreditCard);
export const getEarningRuleByName = createVersionedFunction(v5.getEarningRuleByName, v6.getEarningRuleByName);
export const getEarningsForConsumer = createVersionedFunction(v5.getEarningsForConsumer, v6.getEarningsForConsumer);
export const getEligibleDevices = createVersionedFunction(v5.getEligibleDevices, v6.getEligibleDevices);
export const getExternalProviders = createVersionedFunction(v5.getExternalProviders, v6.getExternalProviders);
export const getFeedbackVote = createVersionedFunction(v5.getFeedbackVote, v6.getFeedbackVote);
export const getFeedbackVoteSummary = createVersionedFunction(v5.getFeedbackVoteSummary, v6.getFeedbackVoteSummary);
export const getLoyaltyPublicDomainConfiguration = createVersionedFunction(
  v5.getLoyaltyPublicDomainConfiguration,
  v6.getLoyaltyPublicDomainConfiguration
);
export const getPayment = createVersionedFunction(v5.getPayment, v6.getPayment);
export const getPaymentMethodClient = createVersionedFunction(v5.getPaymentMethodClient, v6.getPaymentMethodClient);
export const getPaymentMethods = createVersionedFunction(v5.getPaymentMethods, v6.getPaymentMethods);
export const getProfile = createVersionedFunction(v5.getProfile, v6.getProfile);
export const getQrCodeDetails = createVersionedFunction(v5.getQrCodeDetails, v6.getQrCodeDetails);
export const getReward = createVersionedFunction(v5.getReward, v6.getReward);
export const getRewardExtended = createVersionedFunction(v5.getRewardExtended, v6.getRewardExtended);
export const getTiers = createVersionedFunction(v5.getTiers, v6.getTiers);
export const getTradeInPublicDomainConfiguration = createVersionedFunction(
  v5.getTradeInPublicDomainConfiguration,
  v6.getTradeInPublicDomainConfiguration
);
export const getUsersConsents = createVersionedFunction(v5.getUsersConsents, v6.getUsersConsents);
export const getUsersPublicDomainConfiguration = createVersionedFunction(
  v5.getUsersPublicDomainConfiguration,
  v6.getUsersPublicDomainConfiguration
);
export const getWithdraw = createVersionedFunction(v5.getWithdraw, v6.getWithdraw);
export const initAuthentication = createVersionedFunction(v5.initAuthentication, v6.initAuthentication);
export const initRegistration = createVersionedFunction(v5.initRegistration, v6.initRegistration);
export const initializeAsynchronousAgeVerificationController = createVersionedFunction(
  v5.initializeAsynchronousAgeVerificationController,
  v6.initializeAsynchronousAgeVerificationController
);
export const isConsumerEligibleForTradeIn = createVersionedFunction(
  v5.isConsumerEligibleForTradeIn,
  v6.isConsumerEligibleForTradeIn
);
export const isEligibleForTrial = createVersionedFunction(v5.isEligibleForTrial, v6.isEligibleForTrial);
export const isWithdrawEligible = createVersionedFunction(v5.isWithdrawEligible, v6.isWithdrawEligible);
export const logout = createVersionedFunction(v5.logout, v6.logout);
export const meProductRegister = createVersionedFunction(v5.meProductRegister, v6.meProductRegister);
export const messagingFormCreateMessage = createVersionedFunction(
  v5.messagingFormCreateMessage,
  v6.messagingFormCreateMessage
);
export const pauseSubscription = createVersionedFunction(v5.updateSubscriptionToPause, v6.updateSubscriptionToPause);
export const performAgeVerificationController = createVersionedFunction(
  v5.performAgeVerificationController,
  v6.performAgeVerificationController
);
export const phoneValidation = createVersionedFunction(v5.verifyPhone, v6.verifyPhone);
export const quizzesGetUserSubmissions = createVersionedFunction(
  v5.getQuizzesUserSubmissions,
  v6.getQuizzesUserSubmissions
);
export const quizzesStoreUserSubmission = createVersionedFunction(
  v5.createQuizzesUserSubmission,
  v6.createQuizzesUserSubmission
);
export const register = createVersionedFunction(v5.register, v6.register);
export const registerInventoryItem = createVersionedFunction(v5.registerInventoryItem, v6.registerInventoryItem);
export const requestExternalCoupon = createVersionedFunction(v5.requestExternalCoupon, v6.requestExternalCoupon);
export const requestPromoCode = createVersionedFunction(v5.requestPromoCode, v6.requestPromoCode);
export const resumeSubscription = createVersionedFunction(v5.updateSubscriptionToResume, v6.updateSubscriptionToResume);
export const setDefaultAddress = createVersionedFunction(v5.setDefaultAddress, v6.setDefaultAddress);
export const setPassword = createVersionedFunction(v5.setPassword, v6.setPassword);
export const showUserSubscription = createVersionedFunction(v5.getUserSubscription, v6.getUserSubscription);
export const storeAddress = createVersionedFunction(v5.storeAddress, v6.storeAddress);
export const storeCancellationRequest = createVersionedFunction(
  v5.createCancellationRequest,
  v6.createCancellationRequest
);
export const subscriptionConfigurations = createVersionedFunction(
  v5.getSubscriptionConfiguration,
  v6.getSubscriptionConfiguration
);
export const unregisterInventoryItem = createVersionedFunction(v5.unregisterInventoryItem, v6.unregisterInventoryItem);
export const updateAddress = createVersionedFunction(v5.updateAddress, v6.updateAddress);
export const updateConsents = createVersionedFunction(v5.updateConsents, v6.updateConsents);
export const updateCustomAttribute = createVersionedFunction(v5.updateCustomAttribute, v6.updateCustomAttribute);
export const updateCustomAttributes = createVersionedFunction(v5.updateCustomAttributes, v6.updateCustomAttributes);
export const updateEmailRequest = createVersionedFunction(v5.updateEmailRequest, v6.updateEmailRequest);
export const updateProfile = createVersionedFunction(v5.updateProfile, v6.updateProfile);
export const updateSubscription = createVersionedFunction(v5.updateSubscription, v6.updateSubscription);
export const userPairInventoryItem = createVersionedFunction(v5.userPairInventoryItem, v6.userPairInventoryItem);
export const userUnregisterInventoryItem = createVersionedFunction(
  v5.userUnregisterInventoryItem,
  v6.userUnregisterInventoryItem
);
export const validateInventoryItem = createVersionedFunction(v5.validateInventoryItem, v6.validateInventoryItem);
export const validateConsumerCanStartSurveyController = createVersionedFunction(
  v5.validateConsumerCanStartSurveyController,
  v6.validateConsumerCanStartSurveyController
);
export const validateSession = createVersionedFunction(v5.validateSession, v6.validateSession);
export const verifyActionVerification = createVersionedFunction(
  v5.verifyActionVerification,
  v6.verifyActionVerification
);
export const verifyAge = createVersionedFunction(v5.verifyAge, v6.verifyAge);
export const verifyPhoneOrEmail = createVersionedFunction(v5.verifyPhoneOrEmail, v6.verifyPhoneOrEmail);
export const verifyReferralCode = createVersionedFunction(v5.verifyReferralCode, v6.verifyReferralCode);
export const updateVideoWatched = createVersionedFunction(v5.updateVideoWatched, v6.updateVideoWatched);

// ---------------------------------------------------------------------------
// Renamed functions (v5 name is canonical, v6 has a different name)
// ---------------------------------------------------------------------------

export const createContest = createVersionedFunction(v5.createContest, v6.createContest);

export const getBuyPrize = createVersionedFunction(v5.getBuyPrize, v6.getBuyPrize);

export const getInventoryItem = createVersionedFunction(v5.getInventoryItem, v6.getInventoryItem);

export const getQrCodeRead = createVersionedFunction(v5.getQrCodeRead, v6.getQrCodeRead);

export const initializeConsumerSurveyStartedController = createVersionedFunction(
  v5.initializeConsumerSurveyStartedController,
  v6.initializeConsumerSurveyStartedController
);

export const listEarnings = createVersionedFunction(v5.listEarnings, v6.listEarnings);

export const listUserInventoryItem = createVersionedFunction(v5.listUserInventoryItem, v6.listUserInventoryItem);

export const listPurchases = createVersionedFunction(v5.listPurchases, v6.listPurchases);

export const listRewards = createVersionedFunction(v5.listRewards, v6.listRewards);

export const listRewardsExtended = createVersionedFunction(v5.listRewardsExtended, v6.listRewardsExtended);

export const listRewardFilters = createVersionedFunction(v5.listRewardFilters, v6.listRewardFilters);

export const verifyConsent = createVersionedFunction(v5.verifyConsent, v6.verifyConsent);

export const registerUserInventoryItem = createVersionedFunction(
  v5.registerUserInventoryItem,
  v6.registerUserInventoryItem
);

export const updateArticleRead = createVersionedFunction(v5.updateArticleRead, v6.updateArticleRead);

export const updateQuizCompleted = createVersionedFunction(v5.updateQuizCompleted, v6.updateQuizCompleted);
